import React, { Component } from 'react';

import { Button, Container } from 'reactstrap';
import CreatePlcSafetyEventForm from '../../components/Forms/CreatePlcSafetyEventForm';

class NewPlcSafetyEvent extends Component {
  goBack(event) {
    event.preventDefault();
    this.props.history.push('/plcSafetyEvents');
  }

  render() {
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <CreatePlcSafetyEventForm />
        </Container>
      </div>
    );
  }
}

export default NewPlcSafetyEvent;
